import React, {useEffect, useState} from 'react';
import styled from 'styled-components';

import {Dropdown, Form, Input, Select} from 'semantic-ui-react';

import './styles.scss';

import {apiGet} from "../services/apiClient";
import InputDropdown from "./Dropdowns/InputDropdown";

const StyledDropdown = styled(Form.Field)`

  .ui.dropdown > .search.icon,
  .ui.dropdown > .delete.icon,
  .ui.dropdown > .dropdown.icon {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    top: 12px;
    right: 0.5rem;
  }

  .ui.dropdown > .clear.dropdown.icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ui.dropdown:not(.multiple), .ui.search.dropdown:not(.multiple), .ui.search.selection.dropdown:not(.multiple) > input.search, .ui.selection.dropdown:not(.multiple), .ui.selection.search.dropdown:not(.multiple) {
    align-items: center;
  }

  .ui.dropdown > .clear.icon:before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .ui.dropdown > .clear.dropdown.icon {
    right: 1.14285714rem;
  }

  .ui.dropdown .menu .item {
    display: flex;
    flex-direction: row-reverse;
    padding: 0.7142857142857143rem 0.8571428571428571rem !important;
    justify-content: flex-end;
    align-items: center;
  }

  .ui.dropdown .menu .bold.item {
    font-weight: 900;
  }


  &:not(.description-for-valid) .ui.dropdown .description + .text {
    color: #aaa;
  }

  .ui.dropdown > .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: top;
  }

  .ui.dropdown:not(.active) > .text {
    margin-left: 53px;
  }

  .ui.dropdown > .text > .description,
  .ui.dropdown .menu > .item > .description {
    margin-left: auto;
    line-height: 0.8571428571428571rem;
    color: #475566;
    white-space: nowrap;
  }

  .label_placeholder {
    font-weight: 700;
    font-size: 16px !important;
    line-height: 22px;
    color: #939697;
  }

  .ui.selection.dropdown {
    border: 1px solid #AAAAAA;
  }
`;

const CountryDropdown = styled(StyledDropdown)`
  z-index: 10;
  position: absolute !important;

  & .country__name {
    margin-left: 40px;
  }

  & .country__flag {
    position: absolute;
    margin-top: -2px;

    &_item {
      margin-left: 4px;
    }
  }

  & > .dropdown {
    background-color: rgba(102, 51, 153, 0) !important;
    width: 40px !important;
    border-color: rgba(0, 0, 0, 0) !important;
  }

  & > .active.dropdown {
    max-width: 100% !important;
    min-width: 210px;
    border-color: #96c8da !important;
    background-color: rgba(255, 255, 255, 1) !important;
  }
`;

const InputBlock = styled.div`
  position: relative;
  width: 100%;
  margin-right: 8px;

  & > .country {
    z-index: 11;
    .ui.dropdown > .dropdown.icon {
      background-image: none !important;
    }
  }

  input {
    padding-left: 40px !important;
  }
`

const CityInput = ({
                       style = {},
                       value,
                       onChange,
                       name,
                       error,
                       isDisabled,
                   }) => {

    const [countries, setCountries] = useState([]);

    const onChangeCountry = (country) => {
        onChange(null, {name: `${name}AddressCountry`, value: country.value});
    };

    useEffect(() => {
        loadCountries(name === 'shipment');
    }, []);

    const loadCountries = (isShipmentAddress) => {
        apiGet("ref/addressies/countries/list?isDefault=false&addressSuggestionType=" + (isShipmentAddress ? 0 : 1))
            .then(data => {
                setCountries(data.entries ? data.entries.map(country => ({
                    key: country.id,
                    text: country.name,
                    value: country.code,
                    image: "country-icon-" + country.code.toLowerCase()
                })) : [])
            });
    }

    const errorText = 'Адрес отправления не найден. Пожалуйста, внесите корректировки';

    return <InputBlock>
        <CountryDropdown
            className={`country`}
            fluid
            control={Select}
            noResultsMessage={'Не найдено'}
            options={countries}
            style={style}
            disabled
            onChange={(e, {value}) => {
                const country = countries.find(c => c.value === value);
                if (country) onChangeCountry(country);
            }}
        />

        <InputDropdown
            className={error}
            name={'city'}
            url={'parcels/addresses/cityAddressSuggestions'}
            disabled={isDisabled}
            value={(value[`${name}Address`] || {}).city || ''}
            onChange={(name, value, values) => onChange(null, {name, value}, values)}
            params={value[`${name}Address`]}
            paramsForSearchFields={[['countryCode']]}
            searchErrorText={errorText}
        />
    </InputBlock>

};


export default CityInput;



// WEBPACK FOOTER //
// ./App/components/CityInput.jsx